import { render, staticRenderFns } from "./reportHistoryDetail.vue?vue&type=template&id=96eedb52&scoped=true&"
import script from "./reportHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./reportHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./reportHistoryDetail.vue?vue&type=style&index=0&id=96eedb52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eedb52",
  null
  
)

export default component.exports